module.exports = __webpack_public_path__ + "eea3a355c64c8bdc02129cfda68f0700.png";